export default "__VITE_ASSET__Droyj5Hs__"